import { Card, Row, Col, Button, Form } from 'react-bootstrap';
import { useEffect, useState, useCallback } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import htmlToDraft from 'html-to-draftjs';
import { EditorState, convertToRaw, ContentState } from 'draft-js';

const NextMeetingCard = ({ homePageData, getHomePageData }) => {

  const { user: authUser } = useSelector(x => x.auth)
  const url = process.env.REACT_APP_URL

  const [announcementVisible, setAnnouncementVisible] = useState(false);
  const [title, setTitle] = useState('');
  const [titleVisible, setTitleVisible] = useState(false);
  const [description, setDescription] = useState(EditorState.createEmpty());
  const [descriptionVisible, setDescriptionVisible] = useState(false);
  const [nextMeetingVisible, setNextMeetingVisible] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true);

  useEffect(() => {
    // console.log('homePageData', homePageData);

    if (homePageData) {
      setAnnouncementVisible(homePageData.announcement?.visible || false)
      setTitle(homePageData.nextMeeting.title?.text || '');
      setTitleVisible(homePageData.nextMeeting.title?.visible || false);
      const descriptionBlock = htmlToDraft(homePageData.nextMeeting.description?.text || '');
      if (descriptionBlock) {
        const contentState = ContentState.createFromBlockArray(descriptionBlock.contentBlocks);
        const editorState = EditorState.createWithContent(contentState);
        setDescription(editorState);
      }
      setDescriptionVisible(homePageData.nextMeeting.description?.visible || false);
      setNextMeetingVisible(homePageData.nextMeeting.visible || false);
    }
    // eslint-disable-next-line
  }, [homePageData]);


  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    const descriptionHtml = draftToHtml(convertToRaw(description.getCurrentContent()));

    const data = {
      "announcement.visible": announcementVisible,
      "nextMeeting.title.text": title,
      "nextMeeting.title.visible": titleVisible,
      "nextMeeting.description.text": descriptionHtml,
      "nextMeeting.description.visible": descriptionVisible,
      "nextMeeting.visible": nextMeetingVisible,
    };

    // console.log('Data to be sent:', JSON.stringify(data, null, 2)); // Log the data being sent

    try {
      const response = await fetch(`${url}/front`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authUser.token}`,
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        // const result = await response.json();
        toast.success('Next Meeting updated successfully!', { position: 'bottom-left' });
        // console.log('Success:', result);
        getHomePageData(); // Refresh the data
      } else {
        const errorResponse = await response.json();
        // console.error('Error response from server:', errorResponse);
        toast.error(`Failed to update Next Meeting! ${errorResponse.error || response.statusText}`, { position: 'bottom-left' });
      }
    } catch (error) {
      // console.error('Error updating Next Meeting:', error);
      toast.error(`Error updating Next Meeting! ${error.message}`, { position: 'bottom-left' });
    }
  }, [authUser.token, announcementVisible, description, descriptionVisible, getHomePageData, nextMeetingVisible, title, titleVisible, url]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === 's') {
        e.preventDefault();

        // Check if the active element is inside this card
        const cardElement = document.getElementById('next-meeting-card'); // Add a unique ID to the card
        if (cardElement && cardElement.contains(document.activeElement)) {
          handleSubmit(e); // Trigger handleSubmit only for this card
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleSubmit]);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed)
  }

  return (
    <Card id='next-meeting-card' className="mb-3 mt-3">
      <Form data-bs-theme={'dark'}>
        <Card.Header onClick={toggleCollapse} style={{ cursor: 'pointer', paddingTop: '5px' }}>
          <Row className="header mb-2">
            <Col xs={11} lg={11} className="title">
              <h5>Next Meeting</h5>
            </Col>
            <Col xs={1} lg={1}>
              <i
                className={`bi ${isCollapsed ? 'bi-caret-down-fill' : 'bi-caret-up-fill'}`}
                style={{ cursor: 'pointer', paddingTop: '5px' }}
              ></i>
            </Col>
          </Row>
        </Card.Header>
        {!isCollapsed && (
          <>
            <Card.Body>
              {/* <Row>
                <Col xs={8} lg={10}>
                  <Form.Check
                    type="checkbox"
                    id="announcementVisible"
                    label="Announcement Visible"
                    checked={announcementVisible}
                    onChange={(e) => setAnnouncementVisible(e.target.checked)}
                  />
                </Col>
              </Row> */}
              <Row className="mb-3">
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Title</Form.Label>
                    <Form.Check
                      type="checkbox"
                      id="titleVisible"
                      label="Visible"
                      checked={titleVisible}
                      onChange={(e) => setTitleVisible(e.target.checked)}
                    />
                    <Form.Control
                      type="text"
                      placeholder="Title"
                      className="formInput"
                      aria-label="Title"
                      name="Title"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Description</Form.Label>
                    <Form.Check
                      type="checkbox"
                      id="descriptionVisible"
                      label="Visible"
                      checked={descriptionVisible}
                      onChange={(e) => setDescriptionVisible(e.target.checked)}
                    />
                    <Editor
                      editorState={description}
                      wrapperClassName="demo-wrapper"
                      toolbarClassName="toolbar-class"
                      editorClassName="editor-class"
                      onEditorStateChange={setDescription}
                      placeholder="Description"
                      toolbar={{
                        options: ['inline', 'blockType', 'list', 'textAlign', 'link'],
                        inline: {
                          options: ['bold', 'italic', 'underline'],
                        },
                        blockType: {
                          inDropdown: false,
                          options: ['Normal', 'H4', 'H5', 'H6'],
                        },
                        fontSize: {
                          visible: false,
                          options: [8, 9, 10, 11, 12, 14, 18],
                        },
                        list: {
                          inDropdown: false,
                          options: ['unordered', 'ordered'],
                        },
                        textAlign: {
                          inDropdown: false,
                        },
                        link: {
                          inDropdown: false,
                        },
                        embedded: {
                          inDropdown: false,
                        },
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>

            <Card.Footer>
              <Row className="mb-3">
                <Col xs={8}>
                  <Form.Check
                    type="checkbox"
                    id="nextMeetingVisible"
                    label="Next Meeting Visible"
                    checked={nextMeetingVisible}
                    onChange={(e) => setNextMeetingVisible(e.target.checked)}
                  />
                </Col>
                <Col xs={4}>
                  <Button variant="primary" className="float-end" onClick={handleSubmit}>
                    <i className='bi bi-floppy'></i> Save
                  </Button>
                </Col>
              </Row>
            </Card.Footer>
          </>
        )}
      </Form>

    </Card>
  );
};

export default NextMeetingCard;